import z from 'zod'
import { StorageUsage } from '../../domain/entities/StorageUsage'

export const StorageUsageSchema = z
	.object({
		armazenamento_contratado_bytes: z.number(),
		armazenamento_usado_bytes: z.number(),
		armazenamento_usado_porcentagem: z.number(),
	})
	.transform((data) => {
		return new StorageUsage(
			data.armazenamento_contratado_bytes,
			data.armazenamento_usado_bytes,
			data.armazenamento_usado_porcentagem,
		)
	})
